export default "#include <common>\n\n// INSERT DEFINE\n\nvoid main() {\n\n\tvec2 particleUV = (gl_FragCoord.xy / resolution.xy);\n\n\t// INSERT BODY\n\n}"